/* ═══ O CÉREBRO DO QUESTIONÁRIO — [2026-08-17] ═══════════════════════════════
   Saiu de dentro da seção para cá porque agora roda em DOIS lugares: na página
   `/pages/quiz` e dentro do popup que abre a partir do cartão da categoria.

   🪤 POR QUE NÃO DEU PARA DEIXAR O <script> NA SEÇÃO: o popup busca a página
     do quiz e injeta o HTML com innerHTML — e `<script>` injetado assim NÃO
     EXECUTA. Sem separar, o popup mostraria as perguntas e nenhum clique
     funcionaria, sem erro nenhum no console.

   Quem chama diz qual é a categoria; esta função não olha o endereço sozinha,
   justamente porque dentro do popup o endereço é o da COLEÇÃO, não o do quiz.
*/
window.EttoreQuiz = (function () {
  'use strict';

  function montar(raiz, cat, opcoes) {
    if (!raiz || raiz.dataset.quizMontado === 'sim') return null;
    raiz.dataset.quizMontado = 'sim';
    opcoes = opcoes || {};
    cat = (cat || '').toLowerCase();

    var blocos = [].slice.call(raiz.querySelectorAll('[data-bloco]'));
    var bloco = blocos.filter(function (b) {
      return (b.dataset.cats || '').split(',').filter(Boolean).indexOf(cat) > -1;
    })[0] || blocos.filter(function (b) { return !b.dataset.cats; })[0] || blocos[0];
    if (!bloco) return null;
    bloco.hidden = false;

    /* 🪤 UM H1 POR PÁGINA — [2026-09-03]. A seção imprime um cabeçalho por
       categoria (luminárias, vasos, reserva) e esconde os que não são o da
       vez; a varredura de 03/09 contou TRÊS H1 na página do quiz. O que está
       `hidden` não é anunciado pelo leitor de tela, mas conta no documento e
       na leitura de máquina. Só aqui se sabe qual bloco ficou de pé — então é
       aqui que os outros viram H2, preservando classe e conteúdo. */
    blocos.forEach(function (b) {
      if (b === bloco) return;
      var h = b.querySelector('h1.quiz-h1');
      if (!h) return;
      var h2 = document.createElement('h2');
      h2.className = h.className;
      h2.innerHTML = h.innerHTML;
      h.parentNode.replaceChild(h2, h);
    });

    var colecao = bloco.dataset.destino || cat || 'all';
    var passos  = [].slice.call(bloco.querySelectorAll('.quiz-p'));
    var fim     = bloco.querySelector('[data-quiz-fim]');
    var voltar  = bloco.querySelector('[data-quiz-voltar]');
    var res     = bloco.querySelector('[data-quiz-res]');
    var cabeca  = bloco.querySelector('[data-quiz-cabeca]');
    var escolhas = [];   /* [{et, rot}] na ordem das perguntas */

    function endereco(tags) {
      return '/collections/' + colecao + (tags.length ? '/' + tags.join('+') : '');
    }

    /* 🔑 A FOTO VEM DO PRÓPRIO PASSO, via `data-foto` no HTML — nunca de uma
       lista aqui dentro. Duas verdades para a mesma imagem é como o editor
       dele passa a mentir. Quem tem a camada de fundo é o popup; se ninguém
       passou `aoTrocarFoto` (é o caso da página `/pages/quiz`), isto não faz
       nada e o quiz roda igual. */
    /* a reserva vale para todo passo sem foto própria: sem ela o cartão vira
       um retângulo preto no meio de uma loja clara, que foi o que ele viu */
    var fotoReserva = bloco.getAttribute('data-foto-reserva') || '';
    function foto(el) {
      if (typeof opcoes.aoTrocarFoto !== 'function') return;
      var url = (el && el.getAttribute && el.getAttribute('data-foto')) || fotoReserva;
      opcoes.aoTrocarFoto(url || '');
    }

    function mostra(n) {
      passos.forEach(function (p, i) { p.hidden = i !== n; });
      foto(passos[n]);
      if (voltar) voltar.hidden = n === 0;
      if (fim) fim.hidden = true;
      if (res) res.hidden = true;
      if (cabeca) cabeca.hidden = false;
    }

    /* 🪤 NÃO MANDAR ANTES DE SABER SE TEM PEÇA. A etiqueta pode não casar com
       nenhum produto e o filtro devolveria coleção vazia. Pergunto a contagem
       e, vindo zero, solto a etiqueta MENOS decisiva (a última respondida) e
       pergunto de novo. Sempre sobra a primeira, que é a que a pessoa mais pesa. */
    function conta(tags) {
      var url = endereco(tags) + '?view=quantas';
      return fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var n = parseInt((t.match(/\d+/) || [0])[0], 10);
          return isNaN(n) ? 0 : n;
        })
        .catch(function () { return -1; });   /* -1 = não deu para saber */
    }

    function texto(el, s) { if (el) el.textContent = s; }

    /* AS DUAS MAIS CARAS — regra dele, [2026-08-17]. Quem ordena por preço é o
       Liquid (`templates/collection.sugestoes.liquid`), porque o JS só conhece
       as etiquetas, não o catálogo. */
    function sugestoes(tags) {
      return fetch(endereco(tags) + '?view=sugestoes', { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }

    function cartao(p) {
      var a = document.createElement('a');
      a.className = 'qr-pc';
      a.href = p.url;
      a.addEventListener('click', function () {
        if (window.EttoreAvisa) window.EttoreAvisa('quiz_peca_clicada', {
          quiz_peca: p.url.split('/').pop(), quiz_preco: p.preco
        });
      });
      /* ═══ O CARTÃO DA PEÇA, PADRÃO DA LOJA — [2026-08-17] ══════════════════
         Ele: *"olha como que está a foto no card, ela tem que preencher o
         quadrado todo, com os preços embaixo, padrão de produto: pix, 4x sem
         juros, preço riscado"*.

         🔑 A FOTO PREENCHE SEM CORTAR PEÇA. Medido: as fotos de produto desta
           loja têm proporção 1:1, e a caixa também — então `cover` cobre o
           quadrado inteiro sem sobrar nem aparar nada. É por isso que aqui dá
           para preencher sem furar a regra de NUNCA CORTAR FOTO DE PRODUTO: a
           caixa tem o mesmo formato da foto, que é a segunda metade da regra.
         🔑 O PREÇO VEM PRONTO DO LIQUID (`preco_html`), montado pelo mesmo
           `ettore-preco` do card da grade. Remontar aqui criaria uma segunda
           regra de preço, e ela divergiria na primeira promoção. */
      var img = p.foto ? '<span class="qr-pc-f"><img src="' + p.foto + '" alt="" loading="lazy"></span>' : '';
      a.innerHTML = img + '<span class="qr-pc-txt"><b></b><span class="qr-pc-pr"></span></span>';
      a.querySelector('b').textContent = p.titulo;
      var cxPreco = a.querySelector('.qr-pc-pr');
      if (p.preco_html) cxPreco.innerHTML = p.preco_html;
      else cxPreco.textContent = p.preco;
      if (!p.disponivel) {
        var esg = document.createElement('em');
        esg.className = 'qr-pc-esg';
        esg.textContent = 'esgotada';
        cxPreco.appendChild(esg);
      }
      return a;
    }

    /* O RESULTADO É UMA TELA, NÃO UM REDIRECIONAMENTO — pedido dele ao ver o
       quiz rodando: *"ir no final dar o resultado, pra pessoa entrar no link
       dos produtos sugeridos"*. Antes daqui o JS mandava direto para a coleção
       e a pessoa nunca via o que tinha respondido. */
    function desenha(n, tagsUsadas, completo, calado) {
      if (!res) return (location.href = endereco(tagsUsadas));
      passos.forEach(function (p) { p.hidden = true; });
      if (fim) fim.hidden = true;
      if (voltar) voltar.hidden = true;
      if (cabeca) cabeca.hidden = true;
      res.hidden = false;
      foto(res);

      var ditas = escolhas.slice(0, completo ? escolhas.length : tagsUsadas.length)
                          .map(function (e) { return e.rot; });
      texto(res.querySelector('[data-qr-n]'), n);
      texto(res.querySelector('[data-qr-lab]'), n === 1 ? 'peça atende o que você disse'
                                                        : 'peças atendem o que você disse');
      texto(res.querySelector('[data-qr-disse]'), ditas.join(' · '));

      /* [2026-09-13] O AVISO "não temos peça que atenda tudo" SAIU. Ele, vendo o
         quiz no ar: *"direto está dando 'não temos uma peça que atende tudo que
         você disse' — não tem que falar isso"*. O afrouxamento do filtro continua
         (é o que garante que sempre saem peças); o que muda é que o resultado
         se apresenta como recomendação, sem confessar o que ficou de fora. */
      var aviso = res.querySelector('[data-qr-aviso]');
      if (aviso) aviso.hidden = true;
      /* 🗑️ O BOTÃO `[data-qr-bt]` NÃO EXISTE MAIS — [2026-08-17]. Era ele que
         levava para a coleção filtrada, e era o defeito que ele descreveu:
         *"está caindo numa página de categoria e não na página do produto
         indicado"*. As duas peças abaixo já vão para `/products/...`. */

      /* As duas peças entram DEPOIS do número, e o número não espera por elas:
         se a busca falhar, o resultado continua de pé com a contagem e o botão.
         Resultado que só existe se uma segunda busca der certo é resultado
         frágil. */
      var caixa = res.querySelector('[data-qr-pecas]');
      if (caixa) {
        caixa.innerHTML = '';
        caixa.hidden = true;
        sugestoes(tagsUsadas).then(function (d) {
          if (!d || !d.pecas || !d.pecas.length) return;
          d.pecas.forEach(function (p) { caixa.appendChild(cartao(p)); });
          /* 🔑 O NÚMERO PASSA A SER O QUE ESTÁ NA TELA — [2026-08-17]. Ele:
             *"no final ele mostra que tem 4 resultados e só mostra 2; fala que
             só tem 2 resultado"*. Estava certo: o número grande contava quantas
             peças ATENDEM ao filtro, e embaixo apareciam as duas mais caras.
             Anunciar quatro e entregar duas é o cartão desmentindo a si mesmo
             no mesmo quadro. Agora o número é a contagem do que ele mostra. */
          texto(res.querySelector('[data-qr-n]'), d.pecas.length);
          texto(res.querySelector('[data-qr-lab]'),
                d.pecas.length === 1 ? 'peça escolhida para o que você disse'
                                     : 'peças escolhidas para o que você disse');
          /* 🪤 A GRADE SEGUE A CONTAGEM, e não o contrário. Fixa em duas
             colunas, uma peça só encostava na esquerda com metade da caixa
             vazia — foi o que ele viu como "não está centralizado". */
          caixa.style.gridTemplateColumns = 'repeat(' + Math.min(d.pecas.length, 2) + ',minmax(0,1fr))';
          caixa.hidden = false;

          /* Sem botão grande, não há mais o caso especial de "uma peça só":
             toda peça na tela É o destino, sempre. */
        });
      }
      /* 🔑 O EVENTO SAI PELO dataLayer, e SÓ SE ALGUÉM JÁ O CRIOU. Medido em
         [2026-08-17]: o GA4 e o GTM desta loja não vêm do tema, entram por
         app. Criar um gtag aqui seria uma segunda instalação concorrendo com
         a que já existe. `quiz_concluido` leva as respostas: é o único ponto
         do site em que a pessoa DIZ o que quer, em vez de eu adivinhar. */
      /* 🔑 O ESTADO SOBREVIVE AO ENVIO DO FORMULÁRIO. A Shopify recusa o
         cadastro por fetch ("Missing CAPTCHA token"), então o formulário
         RECARREGA a página — e sem isto a pessoa voltaria para uma loja
         qualquer, com o resultado dela perdido e o cupom junto. Guardado
         aqui, o questionário reabre exatamente onde estava. */
      try {
        sessionStorage.setItem('ettore-quiz-estado', JSON.stringify({
          cat: colecao, tags: tagsUsadas, n: n, completo: completo,
          ditas: escolhas.map(function (e) { return e.rot; })
        }));
      } catch (e) {}

      /* as respostas viajam junto do e-mail: é o que deixa o fluxo falar da
         peça que ela escolheu, em vez de mandar o mesmo texto para todos */
      var campoTags = res.querySelector('[data-qr-tags]');
      if (campoTags) {
        var base = campoTags.getAttribute('value') || '';
        campoTags.value = base + (tagsUsadas.length ? ',' + tagsUsadas.join(',') : '');
      }

      /* 🪤 NA RETOMADA ESTE EVENTO NÃO PODE SAIR DE NOVO. Depois do envio do
         formulário a tela final é REDESENHADA, e sem este `calado` o mesmo
         questionário contaria DUAS conclusões no GA4 — uma antes do cadastro
         e outra depois. Medido: a retomada disparava `quiz_concluido` junto
         com `quiz_email_enviado`. Métrica inflada é pior que métrica ausente,
         porque parece que funciona. */
      if (!calado && window.EttoreAvisa) window.EttoreAvisa('quiz_concluido', {
        quiz_categoria: colecao,
        quiz_respostas: tagsUsadas.join(','),
        quiz_pecas: n,
        quiz_completo: completo ? 'sim' : 'parcial'
      });

      if (typeof opcoes.aoTerminar === 'function') opcoes.aoTerminar(n);
    }

    function decide() {
      if (fim) fim.hidden = false;
      passos.forEach(function (p) { p.hidden = true; });
      if (voltar) voltar.hidden = true;
      var todas = escolhas.map(function (e) { return e.et; }).filter(Boolean);
      var tags = todas.slice();
      (function tenta() {
        conta(tags).then(function (n) {
          if (n === -1) return (location.href = endereco(tags));  /* sem resposta: vai assim mesmo */
          if (n > 0 || tags.length === 0) return desenha(n, tags, tags.length === todas.length);
          tags.pop();
          tenta();
        });
      })();
    }

    function reinicia() {
      escolhas = [];
      mostra(0);
    }

    bloco.addEventListener('click', function (e) {
      var b = e.target.closest('.quiz-r');
      if (b) {
        var n = passos.indexOf(b.closest('.quiz-p'));
        escolhas[n] = { et: b.getAttribute('data-etiqueta'), rot: b.textContent.trim() };
        escolhas = escolhas.filter(Boolean);
        if (n + 1 < passos.length) mostra(n + 1); else decide();
        return;
      }
      if (e.target.closest('[data-qr-cupom]')) {
        var cx = e.target.closest('[data-qr-cupom]');
        var cod = cx.querySelector('[data-qr-cod]');
        if (cod && navigator.clipboard) navigator.clipboard.writeText(cod.textContent.trim());
        cx.classList.add('feito');
        var b = cx.querySelector('button');
        if (b) b.textContent = 'Copiado';
        if (window.EttoreAvisa) window.EttoreAvisa('quiz_cupom_copiado', { quiz_cupom: cod ? cod.textContent.trim() : '' });
        return;
      }
      if (e.target.closest('[data-qr-refaz]')) { reinicia(); return; }
      if (e.target.closest('[data-quiz-voltar]')) {
        var atual = passos.findIndex(function (p) { return !p.hidden; });
        if (atual > 0) { escolhas.length = atual - 1; mostra(atual - 1); }
      }
    });

    /* 🔑 RETOMAR É REDESENHAR, NÃO REFAZER. Depois do envio do formulário a
       página volta do zero; em vez de simular três cliques (que dispararia o
       evento de conclusão outra vez e contaria o mesmo quiz duas vezes),
       redesenho a tela final com o que estava guardado. */
    function retoma(estado) {
      if (!estado || !estado.tags) return false;
      escolhas = (estado.ditas || []).map(function (r, i) {
        return { et: estado.tags[i] || '', rot: r };
      });
      desenha(estado.n, estado.tags, estado.completo, true);   /* calado: ver a armadilha no desenha() */
      return true;
    }

    mostra(0);
    return { reinicia: reinicia, retoma: retoma, bloco: bloco };
  }

  return { montar: montar };
})();

/* 🔴 [2026-09-12] QUEM POSTOU FICA MARCADO. O formulário de e-mail do quiz (.qr-form-raiz) e o do
   pop-up de cupom voltam com o MESMO `?customer_posted=true`; sem a marca os dois reagiam e a tela
   de resultado do quiz reabria por cima do cupom (ele viu, com um quiz feito na mesma sessão).
   Delegado no document porque o formulário nasce dentro do pop-up do quiz, redesenhado por fetch. */
document.addEventListener('submit', function (e) {
  if (e.target && e.target.closest && e.target.closest('.qr-form-raiz')) {
    try { sessionStorage.setItem('ettore-postou', 'quiz'); } catch (x) {}
  }
});
